<template>
  <div>
    <page-intro>
      <template v-slot:heading>
        Техническая поддержка
      </template>
      <template v-slot:info>
        Отправляйте свои вопросы через форму обратной связи. Ответ вы получите на почту указанную при регистрации основного пользователя. Техподдержка работает круглосуточно без выходных
      </template>
      <template v-slot:controls>
        <el-button
          type="primary"
          class="w-100"
          :disabled="!$store.state.user.accInfo.isAdmin && !$store.state.user.accInfo.hasAccountAccess"
          @click="requestModalOpened = true">
          Новое обращение
        </el-button>
      </template>
    </page-intro>
    <div class="widget">
      <div class="widget__head">
        <h3 class="widget__title">Мои обращения</h3>
      </div>
      <div v-loading="$mip('getSupportRequests')" class="widget__body">
        <div class="container">
          <div class="row">
            <div class="col-sm">
              <div class="mr-16">
                <span class="status-dot mr-8 bg-success" /> Получен ответ от технической поддержки
              </div>
              <div class="mr-16">
                <span class="status-dot mr-8 bg-error" /> Ожидает ответ от технической поддержки
              </div>
              <div class="mr-16">
                <span class="status-dot mr-8" /> Вопрос завершен
              </div>
            </div>
            <div class="col-sm">
              <div>Сначала показать:</div>
              <el-select v-model="statusSort" clearable @change="sortRequestsByStatus">
                <el-option
                  v-for="option in statusSortOptions"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value" />
              </el-select>
            </div>
          </div>
        </div>

        <paginator :full-data="requests" controls-class="mt-24 flex-x-center">
          <template v-slot="{ page }">
            <div v-for="request in page" :key="request.id">
              <div class="divider" />
              <router-link
                :to="{
                  name: 'supportRequest',
                  params: { supportRequestId: request.id }
                }" class="flex flex-x-between">
                <h3>
                  <span
                    class="status-dot mr-8"
                    :class="getStatusClass(request.status)" />
                  №{{ request.number }}
                  {{ request.topic }}
                </h3>
                <div>{{ formatDate(request.date) }}</div>
              </router-link>
            </div>
          </template>
        </paginator>
      </div>
    </div>

    <request-modal :visible.sync="requestModalOpened" @update-list="getRequests" />
  </div>
</template>

<script>
  import PageIntro from '@/components/PageIntro.vue'
  import Paginator from '@/components/Paginator.vue'
  import RequestModal from './RequestModal.vue'
  import { formatDate } from '@/utils'

  import { sortBy } from 'lodash-es'

  export default {
    components: {
      PageIntro,
      Paginator,
      RequestModal
    },

    data() {
      return {
        requestModalOpened: false,
        statusSort: 'new',
        pageSize: 10,
        requests: [],
        statusSortOptions: [
          {
            value: 'new',
            label: 'Новые'
          },
          {
            value: 'answered',
            label: 'Ответ получен'
          },
          {
            value: 'awaited',
            label: 'Ожидает ответа'
          },
          {
            value: 'ended',
            label: 'Вопрос закрыт'
          }
        ]
      }
    },

    async created() {
      this.getRequests()
    },

    methods: {
      formatDate,
      getStatusClass(status) {
        switch (status) {
          case 'answered':
            return 'bg-success'
          case 'awaited':
            return 'bg-error'
          default:
            return null
        }
      },

      sortRequestsByStatus(status) {
        if (status === 'new') {
          this.requests = sortBy(this.requests, [
            req => -(new Date(req.date))
          ])
        } else {
          this.requests = sortBy(this.requests, [
            req => !(req.status === status),
            req => -(new Date(req.date))
          ])
        }
      },

      async getRequests() {
        const { data } = await this.$http.getSupportRequests()
        this.requests = data
      }
    }
  }
</script>